export default {
    // common
    yes: 'Ja',
    no: 'Nein',
    cancel: 'annullieren',
    all: 'alle',
    athlete: 'Athlet | Athleten',
    coach: 'Trainer | Trainer',
    filter: 'Filter',
    closeFilter: 'Filter schließen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    save: 'speichern',
    clear: 'löschen',
    submit: 'absenden',
    loadMore: 'mehr anzeigen',
    more: 'mehr',
    everybody: 'Alle',
    close: 'schließen',
    next: 'weiter',
    or: 'oder',
    help: 'Hilfe',
    add: 'hinzufügen',
    create: 'Erstellen',
    update: 'aktualisieren',
    finish: 'Ende',
    createAndContinue: 'Speichern und neu hinzufügen',
    any: 'Irgendein',
    areYouSureToDeleteThisFile: 'Are you sure you want to delete this file?',
    browse: 'Browse',

    // login and sign up
    login: 'Registrieren und anmelden',
    google: 'Google',
    invalidEmailAddress: 'Ungültige E-Mail-Adresse',
    emptyPassword: 'Kennwort kann nicht leer sein',
    signUp: 'Anmelden',
    forgotPassword: 'Kennwort vergessen',
    signUpForNewAccount: 'Oder <span class="text-danger">melden Sie sich</span> für ein neues Konto an',
    resetPassword: 'Kennwort zurücksetzen',
    repeatPassword: 'Kennwort wiederholen',
    backToLogin: 'zurück zur Anmeldung',
    yourFirstName: 'Ihr Vorname',
    yourLastName: 'Ihr Nachname',
    yourPassword: 'Ihr Kennwort',
    youEmailAddress: 'Ihre E-mail',
    success: 'Erfolg',
    iAccept: 'Ich akzeptiere',
    termsAndConditions: 'Geschäftsbedingungen',
    privacyPolicy: 'Datenschutz-Bestimmungen',
    receiveProductUpdates: 'Erhalten Sie Produktaktualisierungen',
    receiveMarketingUpdates: 'Erhalten Sie Marketing-Updates',
    firstNameIsRequired: 'Vorname erforderlich',
    lastNameIsRequired: 'Nachname erforderlich',
    passwordIsRequired: 'Kennwort erforderlich',
    passwordConfirmationIsRequired: 'Kennwort-Bestätigung erforderlich',
    needToAcceptTermsAndConditions:
        'Sie müssen die Allgemeinen Geschäftsbedingungen akzeptieren, um sich zu registrieren',
    needToAcceptPrivacyPolicy: 'Sie müssen unsere Datenschutzbestimmungen akzeptieren, um sich registrieren zu können',
    successfulSignUp: 'Registrierung erfolgreich',
    successfulSignUpMessage:
        'You have successfully created an Account in Ludum. Please check your email in order to validate your ' +
        'account and login.',

    // header dropdown
    addMorningMonitoring: 'Morgenüberwachung hinzufügen',
    addDiaryEntry: 'Neuer Tagebucheintrag',
    newSession: 'Neue Trainingseinheit',
    newEvent: 'Neues Ereignis',
    myProfile: 'Mein Profil',
    manageSettings: 'Einstellungen verwalten',
    logout: 'Ausloggen',
    edit: 'Bearbeiten',
    remove: 'Entfernen',
    favourite: 'Favorit',
    joinAClub: 'Einem Verein beitreten',
    createClub: 'Verein erstellen',
    toggleMenu: 'Menü umschalten',
    schedule: 'Zeitplan',
    hours: 'Stunden',
    minutes: 'Minuten',

    // side navigation
    home: 'Home',
    dashboard: 'Instrumententafel',
    sessions: 'Trainingseinheiten',
    mySquads: 'meine {label}',
    reports: 'Berichte',
    clubMembers: 'Vereinmitglieder',
    facebook: 'Facebook',
    twitter: 'Twitter',
    instagram: 'Instagram',
    allRightsReserved: 'Alle Rechte vorbehalten',
    tcs: 'GB',
    english: 'English',
    german: 'Deutsch',
    chinese: 'Chinesisch',
    switchToAdmin: 'Wechseln Sie zu Admin',

    // settings
    accountDetails: 'Kontodetails',
    integrations: 'Integrationen',
    myClubs: 'Meine Vereine',
    billing: 'Abrechnungen',
    requestToJoinClub: 'Anfrage für Mitgliedschaft in einem Verein',

    // settings - account details
    secondaryEmail: 'Alternative E-Mail',
    locationAndTimezone: 'Standort / Zeitzone',
    gender: 'Geschlecht',
    height: 'Höhe',
    cm: 'cm',
    male: 'männlich',
    female: 'weiblich',
    weight: 'Gewicht',
    kg: 'kg',
    maxHeartRate: 'Maximale Herzfrequenz',
    selectedClub: 'Ausgewählte Vereine',
    scull: 'Skull',
    sweep: 'Sweep',
    cox: 'Steuermann /-frau',
    bowStarboard: 'Backbord',
    strokesidePort: 'Steuerbord',
    both: 'Beide',
    username: 'Benutzername',
    password: 'Kennwort',
    oldPassword: 'Altes Kennwort',
    newPassword: 'Neues Kennwort',
    reenterPassword: 'Kennwort erneut eingeben',
    changeImage: 'Bild ändern',
    chooseSide: 'Riemen Seite auswählen',
    dataSuccessfullySaved: 'Daten wurden erfolgreich gespeichert',
    details: 'Details',
    contactNumber: 'Kontaktnummer',

    // settings - integrations
    thirdParty: 'Drittpartei',
    status: 'Status',
    account: 'Konto',
    action: 'Aktion',
    connected: 'Verbunden',
    notConnected: 'Nicht verbunden',
    connect: 'Verbinden',
    disconnect: 'Trennen',
    floatIntegration: 'Float-Integration',
    garminIntegration: 'Garmin-Integration',
    redirectingToIntegrationsPage: 'Weiterleitung zur Integration Seite',

    // settings - my clubs
    selectImage: 'Bild auswählen',
    club: 'Verein',
    position: 'Position',
    areYouSureToLeaveClub: 'Möchtest du den Verein wirklich verlassen?',
    areYouSureToJoinClub: 'Bist du sicher, dass du dem Verein beitreten möchtest?',
    successfullyLeftClub: 'Du hast den Verein erfolgreich verlassen',
    leave: 'Verlassen',
    rejoin: 'erneut Gruppe beitreten',
    name: 'Name',
    description: 'Beschreibung',
    country: 'Land',
    searchForClub: 'Suche nach einem Verein',
    noResultsForSearchedTerm: 'Keine Ergebnisse für gesuchten Begriff',
    sendRequest: 'Anfrage senden',
    gmt: 'Zielzeiten',
    gmts: 'Zielzeiten',
    clubDetails: 'Vereindetails',
    wb: 'Weltrekord',
    gmtDistribution: 'Zielzeiten-Verteilung',

    // settings - club list
    areYouSureToAcceptInvitation: 'Sind Sie sicher, dass Sie die Einladung dieser Gruppe annehmen möchten?',
    areYouSureToRejectInvitation: 'Sind Sie sicher, dass Sie die Einladung dieser Gruppe ablehnen möchten?',

    // settings - edit club - defaults
    defaults: 'Standardwerte',
    allYourSessionsAreSetTo: 'alle Ihre Einheiten sind eingestellt auf…',
    competitive: 'Wettkampfstarter',
    nonCompetitive: 'keine Wettkämpfe',

    // settings-dashboard-add crew auto import
    autoImportValueAutomatic: 'Import Automatically',
    assignManually: 'Assign Manually',
    autoImportValueOff: 'Do not import',
    ignore: 'ignorieren',
    viewAllThirdPartyIntegrations: 'Alle Integrationen von Drittanbietern anzeigen',
    connectThirdParties: 'Mit anderen Drittanbietern verbinden',
    connectThirdPartiesMessage:
        'Durch Verknüpfungen mit Drittanbietern können Sie problemlos Trainingseinheiten, ' +
        'Herzfrequenzen und andere Daten importieren. Wir integrieren diese in Ihr Ludum-Konto und helfen Ihnen, die ' +
        'Plattform optimal zu nutzen',
    previous: 'Vorherige Anzeige',
    completedOn: 'Vervollständigt um',
    assignDataToSessionOrCreateNewSession:
        'Übertrage deine Daten in eine bereits angelegte Trainingseinheit oder erstelle eine neue mit diesen Daten.',
    assignToExistingSession:
        'Übertrage deine Daten in einen bereits angelegte Trainingseinheit oder erstelle automatisch eine ' +
        'neue Trainingseinheit.',
    createNewSession: 'Neue Trainingseinheit erstellen',
    howDidYouFindSession: 'Wie anstrengend hast du das Training empfunden?',
    createSessionAs: 'Erstelle die Trainingseinheit als…',
    autoImportEmptyAgendaMessage: 'Du hast keine Trainingseinheiten, um die Daten zu importieren.',
    assignToSession: 'Daten in Trainingseinheit übertragen',
    importAsA: 'Importiern als',
    selectClub: 'Verein auswählen',
    assignToClub: 'Einem Verein zuweisen',
    doYouWantToCreateCrew: 'Möchten Sie eine Mannschaft für diesen automatischen Import erstellen?',
    waterSessionAutoImportInitialMessage:
        'Um den automatischen Import abzuschließen, erstellen Sie bitte eine neue Mannschaft und weisen Sie ' +
        'sich selbst zu.',
    noCrew: 'Keine Mannschaft',

    // squads
    squad: 'Gruppe | Gruppe',
    addSquad: '{label} erstellen',
    editSquad: '{label} bearbeiten',
    deleteSquad: '{label} löschen',
    saveSquad: '{label} speichern',
    areYouSureToDeleteSquad: 'Möchten Sie die {label} wirklich löschen?',
    squadsCount: 'Gruppenanzahl',
    allSquads: 'Alle {label}',
    squadName: '{label} Name',
    selectBySquad: 'NACH {label} AUSWÄHLEN',
    selectByAthletes: 'NACH ATHLETEN AUSWÄHLEN',
    selectByIndividuals: 'Auswahl nach einzelnem Sportler/Trainer',
    healthy: 'Gesund',
    ill: 'Krank',
    injured: 'Verletzt',
    assigned: 'Zugewiesen',
    illBadge: 'Ill',
    injuredBadge: 'Injured',

    // club members
    sortBy: 'Sortiere nach',
    invite: 'Einladen',
    multiInvite: 'Mehrfach einladen',
    number: 'Telefonnummer',
    dateOfBirth: 'Geburtsdatum',
    accept: 'Akzeptieren',
    reject: 'Ablehnen',
    bulkAction: 'Massenaktion',
    areYouSureToRemoveMember: 'Möchtest du das Mitglied wirklich entfernen?',
    invitee: 'Eingeladener',
    clubManager: 'Vereinmanager',
    acceptAndAssign: 'Akzeptieren und Zuweisen',
    editMember: 'Mitglied bearbeiten',
    roleInClub: 'Rolle im Verein',
    permissionsInClub: 'Berechtigungen in einem Verein',
    inviteMember: 'Mitglied einladen',
    sendInvitation: 'Einladung senden',
    selectRole: 'Funktion auswählen',
    multiImport: 'Mehrfachimport',
    uploadFile: 'Datei hochladen',
    downloadSample: 'Beispiel herunterladen',
    manager: 'Manager | Manager',
    invited: 'Eingeladen',
    pending: 'Ausstehend',
    left: 'Verlassen',
    removeMember: 'Mitglied entfernen',
    acceptMember: 'Mitglied annehmen',
    rejectMember: 'Mitglied ablehnen',
    resendInvitation: 'Einladung erneut versenden',
    role: 'Rolle | Rollen',

    // wall posts
    wallPost: 'Wall Post | Wall Posts',
    writeSomething: 'Etwas schreiben ...',
    attachImageOrFile: 'Bild oder Datei anhängen',
    post: 'Eintragen',
    wrote: 'schrieb',
    comment: 'Kommentar | Kommentar',
    like: 'Mögen',
    uploadingFile: 'Anhänge werden geladen ...',
    areYouSureToDeleteWallPost: 'Möchtest du diesen Eintrag wirklich löschen?',
    file: 'File | Files',
    photo: 'Photo | Photos',
    video: 'Video | Videos',
    document: 'Document | Documents',

    // add morning monitoring
    selectDate: 'Datum auswählen',
    wakingHr: 'rHFA',
    standingHr: 'sHFA',
    bpm: '1/min',
    bodyMass: 'Körpermasse',
    hydration: 'Hydration',
    hydrated: 'hydriert',
    yesterdayTraining: 'Gestriges Training',
    sleepQuality: 'Schlafqualität',
    lowScoreEffectedBy: 'Mein niedriger Punktestand wird beeinflusst durch',
    perceivedShape: 'Wahrgenommene Form',
    other: 'Andere',

    // session
    overview: 'Überblick',
    results: 'Ergebnisse',
    crew: 'Mannschaft | Mannschaften',
    attendance: 'Teilnahme',
    addScores: 'Wert hinzuzufügen',
    attending: 'Teilnehmen',
    notAttending: 'Nicht teilnehmen',
    alternative: 'Alternative',
    createdBy: 'Erstellt von',
    lastEditedBy: 'Zuletzt bearbeitet von',
    emptyCrewCreateCrew: 'Mannschaften für diese Trainingseinheiten erstellen',
    crewNoResults: 'Keine Ergebnisse',
    on: 'auf',
    areYouSureToDeleteSession: 'Möchten Sie diese Trainingseinheit wirklich löschen?',
    youHaveChangedYourClub: 'Sie haben Ihren Verein gewechselt',
    alreadyInCrewOnThisSession: 'Athleten von anderen Mannschaften in dieser Trainingseinheit',

    // session - attendance
    athletesName: 'Athleten Name',
    allAttending: 'Alle teilnehmen',
    allNotAttending: 'Alle nicht teilnehmen',
    coachesName: 'Trainer Name',

    // session - overview
    plannedDistance: 'Geplante Distanz',
    plannedTime: 'Geplante Zeit',
    noOfPieces: 'Anzahl der Teilstrecken',
    noOfExercises: 'Anzahl der Übungen',
    noOfCrews: 'Anzahl der Mannschaften',
    rpe: 'RPE',
    avgRpe: 'durchschnittliches RPE',
    notSet: 'Nicht eingegeben',
    workStructure: 'Arbeitsstruktur',
    noWorkStructure: 'Keine Arbeitsstruktur',
    createWorkStructure: 'Arbeitsstruktur erstellen',
    exercise: 'Übung | Übungen',
    group: 'Gruppe',
    total: 'Gesamt',
    participants: 'Teilnehmer',
    addParticipants: 'Teilnehmer hinzufügen',
    noParticipantsInThisSession: 'Keine Teilnehmer in dieser Trainingseinheit',
    addAthletes: 'Athleten hinzufügen',
    searchForAthletes: 'Athleten suchen',
    emptyAthleteSlot: 'Leerer Sitz',

    // session - crew
    addCrew: 'Mannschaft hinzufügen | Mannschaft hinzufügen',
    filterAthletes: 'Athleten filtern',
    boatType: 'Bootstyp',
    createCrew: 'Mannschaft erstellen | Mannschaften erstellen',
    updateCrew: 'Mannschaft  aktualisieren | Mannschaften  aktualisieren',
    newCrew: 'Neue Mannschaft',
    crewName: 'Name der Mannschaft',
    swapAthletes: 'Athleten tauschen',
    noAthletes: 'Keine Athleten in dieser Gruppe',
    seat: 'Sitz',
    allPieces: 'Alle Strecken',
    selectPieces: 'Strecken auswählen',
    addFavourite: 'Favorit hinzufügen',
    stroke: 'Schlag',
    undefined: 'Nicht definiert',
    noCrews: 'Keine Mannschaften für diese Einheit',
    unassignedCrews: 'Nicht zugewiesene Mannschaften',
    favouriteCrews: 'Favorit',
    recentCrews: 'Kürzliche Mannschaften',
    assignCrew: 'Mannschaft zuweisen',
    selectCrew: 'Mannschaft auswählen',
    generalNoCrews: 'Keine Mannschaften',
    copyToAllPieces: 'In alle Strecken kopieren',
    filterBoats: 'Boote filtern',
    notifyCrew: 'Mannschaften benachrichtigen',
    unassigned: 'Nicht zugewiesen',
    recent: 'Kürzlich',
    favouriteCrewsListEmpty: 'Ihre Favoriten-Liste ist lehr',
    selectABoatFromAbove: 'Wählen Sie ein Boot von oben',
    updateFavouriteCrew: 'Aktualisiere Favoriten Mannschaft',
    bow: 'Bug',
    sculler: 'Skuller',
    box: 'Box',

    // session - results
    session: 'Trainingseinheit | Trainingseinheiten',
    alternativeOverallSummary: 'Alternative Gesamtzusammenfassung',
    alternativeType: 'Alternativtyp',
    split: 'Split',
    aveSplit: 'Durchschnittliche Split-Zeit',
    min: 'Mindest',
    heartRate: 'Herzfrequenz',
    gps: 'GPS',
    overall: 'Insgesamt',
    barGraph: 'Balkendiagramm',
    lineGraph: 'Liniendiagramm',
    time: 'Zeit',
    gpsTime: 'GPS-Zeit',
    bike: 'Fahrrad',
    ergo: 'Ergometer',
    sc: 'Krafttraining',
    swim: 'Schwimmen',
    water: 'Wasser',
    run: 'Laufen',
    length: 'Länge',
    score: 'Ergebnis',
    aveScore: 'durchschnittliches Ergebnis',
    rank: 'Platzierung',
    aveHr: 'durchschnittliche Herzfrequenz',
    hr: 'Herzfrequenz',
    aveWatts: 'durchschnittliche Watts',
    watts: 'Wattwerte',
    aveCadence: 'durchschnittliche Kadenz',
    cadence: 'Kadenz',
    aveLactates: 'durchschnittliches Lactate',
    lactates: 'Lactat(werte)',
    lactate: 'Lactate',
    totalTime: 'Gesamtzeit',
    totalDistance: 'Gesamtdistanz',
    pace: 'Geschwindigkeit',
    avePace: 'durchschnittliche Geschwindigkeit',
    avePacePiece: 'durchschnittliche Pace-Geschwindigkeit',
    peakPower: 'Höchstleistung',
    rate: 'Frequenz',
    aveRate: 'Durchschnittliche Frequenz',
    aveRpe: 'Durchschnittliches RPE',
    power: 'Kraft',
    strokeLength: 'Schlaglänge',
    energy: 'Energie',
    avePeakForce: 'Durchschnittliche Maximalkraft',
    realPeakForcePosition: 'Spitzenkraft Position',
    dateDone: 'Datum fertig',
    segments: 'Segmente',
    resultsSummary: 'Zusammenfassung der Ergebnisse',
    sessionComparisons: 'Trainingseinheitsvergleiche',
    scoreComparisons: 'Ergebnisvergleiche',
    values: 'Werte',
    individuals: 'Einzelpersonen',
    type: 'Art',
    wKg: 'W / Kg',
    aveWKg: 'Durchschnittlich W / Kg',
    ergoType: 'Ergo-Typ',
    overallSummary: 'Gesamtübersicht',
    liftsByAthlete: 'Hebungen von Athleten',
    liftByExercise: 'Hebungen pro Übung',
    set: 'Reihe | Reihen',
    rep: 'Wiederholung | Wiederholungen',
    chooseAthlete: 'Wähle Athlet',
    totalTonnage: 'Gesamttonnage',
    totalWeight: 'Gesamtgewicht',
    speed: 'Geschwindigkeit',
    speedMs: 'Geschwindigkeit (m / s)',
    aveSpeed: 'Durchschnittsgeschwindigkeit',
    maxSpeed: 'Maximale Geschwindigkeit',
    maxPace: 'Maximale Pace-Geschwindigkeit',
    maxHr: 'max HF',
    timeLessThenHalfSecond: 'Zeit <0,5 m / s',
    crewGmtLevels: 'Mannschafts- Zielzeiten ',
    percentageInEachGmtLevel: '% in jeder Zielzeit',
    percentageGmt: 'Prozent-Zielzeit (% gmt)',
    aveTime: 'Durchschnittliche Zeit',
    aveDistance: 'Durchschnittliche Entfernung',
    crewsMap: 'Mannschaftsmappe',
    athletesMap: 'Athletenmappe',
    speedGraph: 'Geschwindigkeitsdiagramm',
    sessionHrByLevels: 'Trainingseinheiten nach HF Stufe',
    percentageInEachHrLevel: '% in jeder HF Stufe',
    level: 'Stufen',
    showAllAthletes: 'Alle Athleten anzeigen',
    hideAllAthletes: 'Alle Athleten ausblenden',
    showAllCrews: 'Alle Mannschaften anzeigen',
    hideAllCrews: 'Alle Mannschaften ausblenden',
    hideAll: 'Alles ausblenden',
    noResults: 'Es wurden keine Ergebnisse hinzugefügt. Bitte fügen Sie Ergebnisse hinzu, um sie anzuzeigen',
    noHeartRateResults:
        'Es wurden keine Herzfrequenzdaten hinzugefügt, bitte fügen Sie Daten hinzu, um die Ergebnisse anzuzeigen',
    noGpsResults: 'Es wurden keine GPS-Daten hinzugefügt. Bitte fügen Sie Daten hinzu, um die Ergebnisse anzuzeigen',

    // session - import data
    importData: 'Daten importieren',
    addIntegration: 'Integration hinzufügen',
    importText: 'EINFÜGEN',
    piece: 'Strecke | Strecken',

    // add score
    addResults: 'Ergebnisse hinzufügen',
    saveAndView: 'speichern und anzeigen',
    saveScores: 'Ergebnisse speichern',
    updateScores: 'Ergebnisse aktualisieren',
    result: 'Ergebnis | Ergebnisse',
    byAthlete: 'Von Athlet',
    byCrew: 'Von der Mannschaft',
    didNotAttend: 'Hat nicht teilgenommen',
    distance: 'Entfernung',
    noOfAthletes: 'Anzahl der Athleten',
    noOfCoaches: 'Anzahl der Trainer',
    data: 'Daten',
    peakForcePosition: 'Spitzenkraft Position',
    toAddScoresAddCrewsRowing:
        'Um der Rudermannschaft Ergebnisse zuzuordnen, musst du zuerst mindestens eine Mannschaft aufbauen',
    toAddScoresAddCrewsKayakCanoe:
        'Um der Kajak/Kanu-Mannschaft Ergebnisse zuzuordnen, musst du zuerst mindestens eine Mannschaft aufbauen',
    startTime: 'Startzeit',
    startDistance: 'Start-Distanz',
    finishTime: 'Zielzeit',
    finishDistance: 'Ziel-Distanz',
    finalTime: 'Endzeit',
    finalDistance: 'Endgültige Distanz',
    multiSport: 'Multi Sport',
    backToSessionType: 'Zurück zum Trainingseinheitstyp',
    sessionListIsEmpty: 'Die Trainingseinheits-Liste ist leer.',
    noAddScoresStructure:
        'Um Ergebnisse hinzuzufügen, erstellen Sie eine Trainingseinheitsstruktur und fügen Sie Athleten hinzu',
    noAddScoresStructureSc:
        'Um Punkte hinzuzufügen, erstellen Sie die richtige Trainingseinheitsstruktur und fügen Sie Teilnehmer hinzu',

    // create session and event
    createSession: 'Trainingseinheit erstellen',
    editSession: 'Trainingseinheit bearbeiten',
    updateSession: 'Trainingseinheit aktualisieren',
    sessionName: 'Name der Trainingseinheit',
    work: 'Strecken',
    permission: 'Berechtigung | Berechtigungen',
    yourSessionWasCreated: 'Ihre Trainingseinheit wurde erstellt',
    viewSession: 'Trainingseinheit anzeigen',
    addMoreDetails: 'Weitere Details hinzufügen',
    addLessDetails: 'Weniger Details hinzufügen',
    location: 'Ort',
    intensity: 'Intensität | Intensitäten',
    focus: 'Schwerpunkt | Schwerpunkte',
    addTags: 'Tags hinzufügen',
    selectExercise: 'Übung auswählen',
    custom: 'Benutzerdefiniert',
    exerciseName: 'Name der Übung',
    addAllScores: 'Alle Ergebnisse eintragen',
    repeat: 'Wiederholen',
    frequency: 'Frequenz',
    daily: 'Täglich',
    weekly: 'Wöchentlich',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    every: 'Alle',
    onThe: 'Auf der',
    each: 'Jeder',
    setBySelectingDays: 'Nach Tagen auswählen',
    setByChoosingFrequency: 'Nach Frequenz auswählen',
    day: 'Tag',
    week: 'Woche',
    month: 'Monat',
    year: 'Jahr',
    first: 'Erster',
    second: 'Zweiter',
    third: 'Dritter',
    fourth: 'Vierter',
    until: 'Bis',
    setEndDate: 'Enddatum festlegen',
    removeEndDate: 'Enddatum entfernen',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mrz',
    apr: 'Apr',
    may: 'Mai',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sep: 'Sept',
    oct: 'Okt',
    nov: 'Nov',
    dec: 'Dez',
    single: 'Einzeln',
    multiple: 'Mehrere',
    variable: 'Variable',
    byDistance: 'Nach Entfernung',
    byTime: 'Nach Zeit',
    repetition: 'Wiederholung | Wiederholungen',
    rest: 'Ruhepause',
    addGroup: 'Gruppe hinzufügen',
    workHeaderMessage:
        'Erstellen Sie eine Streckenstruktur welche auf dem Ergo ausgeführt wird. Sie können dies jederzeit ' +
        'später hinzufügen oder Athleten können ihre eigenen hinzufügen.',
    createEvent: 'Ereignis erstellen',
    editEvent: 'Ereignis bearbeiten',
    updateEvent: 'Ereignis aktualisieren',
    eventName: 'Ereignis Name',
    yourEventWasCreated: 'Ereignis wurde erstellt',
    viewEvent: 'Ereignis anzeigen',
    cannotRemove: 'Der Ersteller kann nicht entfernt werden.',
    nameGoesHere: 'Name hier',
    infoTooltipEditSessionText: 'Mit dieser Berechtigung kann der Benutzer die Trainingseinheit bearbeiten.',
    infoTooltipAddAllScoresSessionText:
        'Mit dieser Berechtigung kann der Benutzer für jeden Athleten Punkte hinzufügen.',
    infoTooltipEditEventText: 'Mit dieser Berechtigung kann der Benutzer das Ereignis bearbeiten.',

    // repeat session
    allFutureEvents: 'Alle zukünftigen Ereignisse',
    onlyThisEvent: 'Nur dieses Ereignis',

    // dashboard
    yourAgenda: 'Deine Agenda',
    view: 'Anzeigen',
    mostRecentSession: 'Letzte Trainingseinheit',
    yourRecentSessionWillAppearHere: 'Ihre letzte Trainingseinheit wird hier angezeigt.',
    today: 'Heute',
    notification: 'Benachrichtigung | Benachrichtigungen',
    nextSession: 'Nächste Trainingseinheit',
    createNextSession: 'Erstellen Sie Ihre nächste Trainingseinheit.',

    // Dashboard - Training Load Scores
    informationAboutScores: 'Informationen zur Trainingsbelastung',
    informationAboutScoresTabText:
        'Durch die Verwendung von Beziehungen zwischen Herzfrequenz, Morgenüberwachung und ' +
        'Sitzungsrückmeldungen ist es möglich, einen kardialen Trainingsbelastungsfaktor zu berechnen. Mit der Zeit kann ' +
        'Ihnen diese Punktzahl helfen, weniger oder mehr zu trainieren und auch Ihre Ergebnisse besser zu verstehen, ' +
        'sowie Verletzungen zu vermeiden.',
    informationAboutScoresTabButton:
        'Verbinden Sie Integrationen, um die Trainingswerte für das Herztraining zu aktivieren',
    informationAboutScoresT2Title: 'ETS',
    informationAboutScoresT2Text:
        'In 2014 hat Rice et al. eine raffiniert Methode zur Berechnung der Trainingsergebnisse für ' +
        'jede Trainingseinheit vorgeschlagen. Der Wert berücksichtigt sowohl die Belastungsintensität als auch die ' +
        'Trainingsart, welche Sie durchführen.',
    informationAboutScoresTrimpTitle: 'TRIMP',
    informationAboutScoresTrimpText:
        'TRIMP (Training Impulse) wurde 1990 von Banister entwickelt und ist ein Maß ' +
        'für die Berechnung der Trainingsbelastung. Der Wert bezieht sich auf die in jeder Trainingssitzung verbrachten Zeit ' +
        'um eine messbare Zahl der Intensität der Trainingseinheit widerzuspiegeln.',
    informationAboutScoresFosterTitle: 'Foster',
    informationAboutScoresFosterText:
        '2001 schlug Foster et al. eine Methode für die Berechnung der Trainingsbelastung vor, für welche keine ' +
        'Herzfrequenzdaten erforderlich sind',
    readMore: 'Weiterlesen',
    compareTo: 'Vergleichen mit',

    // new dashboard
    clubTraining: 'Verein Training',
    cardiacTrainingLoad: 'Herz-Kreislauf-Trainingsbelastung',
    ct: 'CT',
    ctl: 'CTL',
    mm: 'MU',
    lastWeek: 'letzte Woche',
    lastMonth: 'letzter Monat',
    lastYear: 'letztes Jahr',
    vs: 'vs',
    thisWeek: 'Diese Woche',
    thisMonth: 'Dieser Monat',
    thisYear: 'Dieses Jahr',
    profile: 'Profil',
    dashboardMorningMonitoringMessage:
        'Es ist wichtig Herzfrequenz, Hydration, Trainingsqualität, ' +
        'Verletzung und Krankheit zu verfolgen, die MorgenÜberwachung hilft Ihnen dabei besser zu verstehen ' +
        'wann und ob Sie Ihren Trainingsplan ändern sollten',
    dontHaveStatsForSelectedPeriod:
        'Keine morgendlichen Überwachungsstatistiken für den ausgewählten Zeitraum vorhanden',
    showCharts: 'Diagramme anzeigen',
    hideCharts: 'Diagramme ausblenden',

    // calendar
    addSession: 'Trainingseinheit hinzufügen',
    addRecentSession: 'Letzte Trainingseinheit hinzufügen',
    myFavourites: 'Meine Favoriten',
    clubFavourites: 'Verein Favoriten',
    allFavourites: 'Alle Favoriten',
    areYouSureToDeleteFavourite: 'Möchtest du diesen Favoriten wirklich löschen?',
    assignMembers: 'Athleten zuweisen',
    pleaseAssignPermissions: 'Bitte weisen Sie Berechtigungen zu. Bestehende Berechtigungen werden ersetzt.',
    assignAndAddPermissions: 'Berechtigungen zuweisen und hinzufügen',
    sessionDataSavedSuccessfully: 'Trainingseinheitsdaten wurden erfolgreich gespeichert.',
    atLeastOneSessionErrorMessage: 'Sie müssen mindestens eine Trainingseinheit vor dem Senden auswählen.',
    note: 'Hinweis | Aufzeichnungen',
    assign: 'Zuweisen',
    loadPastSession: 'Vergangene Trainingseinheiten laden',
    deleteSelectedSessions: 'Ausgewählte Trainingseinheiten löschen',
    showingResultsFrom: 'Ergebnisse anzeigen von',
    to: 'bis',
    emptyResultsSet: 'Ausgewählte Ergebnisse leeren.',
    areYouSureToDeleteSelectedEvent: 'Möchten Sie das ausgewählte Ereignis wirklich löschen?',
    eventsSuccessfullyDeleted: 'Ereignisse wurden erfolgreich gelöscht.',
    searchTags: 'Suche Tags',
    searchAthletes: 'Suche Athleten',
    date: 'Datum | Zeitraum',
    start: 'Anfang',
    end: 'Ende',
    mySessions: 'Meine Trainingseinheiten',
    allSessions: 'Alle Trainingseinheiten',
    sessionType: 'Art der Trainingseinheit | Arten der Trainingseinheiten',
    allDay: 'Ganzer Tag',
    selectAll: 'Alle auswählen',
    list: 'Liste',
    weeklySummary: 'Wöchentliche Zusammenfassung',
    trainingType: 'Trainingsart | Trainingsarten',
    editSessionPermissionsErrorMessage: 'Sie haben keine Berechtigung um diese Trainingseinheit zu bearbeiten',
    editEventPermissionsErrorMessage: 'Sie haben keine Berechtigung um dieses Ereignis zu bearbeiten',
    quickAssign: 'Schnellzuweisung',
    unselectAll: 'Auswahl aufheben',
    youHaveToSelectSessionFirst: 'You have to select a session first.',
    selectSession: 'Select session',
    doYouWantToCreateSessionOn: 'Do you want to create session on {date}?',

    // Profile
    theirAgenda: 'Ihre Agenda',
    noSessionsPlanned: 'Derzeit sind keine Trainingseinheiten geplant',
    noSessionComing: 'Keine Trainingseinheiten sind geplant, planen Sie Ihre nächste Trainingseinheit.',
    morningMonitoring: 'Morgenüberwachung',
    hrZones: 'HF-Zonen',
    todayMorningMonitoringSummaries: 'Heutige Zusammenfassungen der Morgenüberwachung',
    changeInHrFromYesterday: 'Änderung der HF von gestern',
    changeInHrFromFiveDaysAve: 'Änderung der HF von 5 Tagen im Durchschnitt',
    differenceInWakingAndStandingHr: 'Unterschied zwischen Ihrer Ruheherzfrequenz im Stehen und jener beim Aufwachen',
    changeInBodyMassFromYesterday: 'Änderung der Körpermasse von gestern',
    changeInPerceivedShape: 'Änderung der wahrgenommenen Form',
    hydrationLevel: 'Hydrationsgrad',
    trainingQuality: 'Trainingsqualität',
    theirMostRecentSession: 'Ihre letzte Trainingseinheit',
    mostRecentSessionWillAppearHere: 'Die letzte Trainingseinheit wird hier angezeigt.',
    past5Sessions: 'Meine letzten 5 Trainingseinheiten',
    pb: 'persönlicher Rekord',
    addData: 'Daten hinzufügen',
    theirNextSession: 'Ihre nächste Trainingseinheit',
    doesnHaveNextSessionPlanned: 'keine nächste Trainingseinheit geplant.',
    isCurrentlyInNoSquads: 'Derzeit gibt es keine {label}.',
    hrWeight: 'HF & Gewicht',
    sleepShape: 'Schlafqualität und Form',
    kilogram: 'Kilogramm | Kilogramm',
    entryBefore: 'vorheriger Eintrag',
    mean: 'Durchschn',
    bodyWeightKg: 'Körpergewicht (kg)',
    sleep: 'Schlaf',
    shape: 'Form',
    severelyDehydrated: 'Stark dehydriert',
    noHydration: 'Keine Hydration',
    thereAreNoNotifications: 'Es gibt keine Benachrichtigungen.',
    settings: 'Einstellungen',
    markAllAsRead: 'Alles als gelesen markieren',
    seeAll: 'Alles sehen',
    notificationSettings: 'Benachrichtigungseinstellungen',
    web: 'Webseite',
    mobile: 'Handy',
    rowingStats: 'Ruderstatistik',

    // profile drv
    drv: 'DRV',
    personal: 'persönlich',
    contactInfo: 'Kontaktinformation',
    degreeAbbreviation: 'Grad Abkürzung',
    title: 'Titel',
    fax: 'Fax',
    address: 'Adresse',
    street: 'Straße',
    postCode: 'Postleitzahl',
    state: 'Land',
    city: 'Stadt',
    federationInfo: 'Informationen zur Föderation',
    clubInfoAndStatus: 'Vereininformationen und Status',
    educationCoachesInfo: 'Info zur Ausbildung des Trainers',
    myDetails: 'Meine Details',
    otherDetails: 'Andere Details',
    rowingDetails: 'Details zum Rudern',
    noResultsWithinDateRange: 'Keine Ergebnisse innerhalb dieses Zeitraumes.',
    training: 'Training',
    physiology: 'Physiologie',
    analysis: 'Analyse',
    trainingAndPerformance: 'Training & Leistung',
    testResultsW: 'Testergebnisse (w)',
    trainingVolume: 'Trainingsumfang',
    injuryIllnessTimeline: 'Timeline von Verletzungen und Krankheit',
    trainingVolumes: 'Trainingsumfang',
    enduranceTraining: 'Ausdauertraining',
    strengthTraining: 'Krafttraining',
    zone: 'Zone | Zonen',
    hour: 'Stunde | Stunden',
    endurance: 'Ausdauer',
    trainingCompleted: 'Training abgeschlossen',
    noOfSessions: 'Anzahl der Einheiten',
    trainingLoad: 'Trainingsbelastung',
    rowingDistance: 'Ruderdistanz',
    injuries: 'Verletzungen',
    illnessTypes: 'Krankheitstypen',
    injuryTypes: 'Arten von Verletzungen',
    manual: 'manuell',
    imported: 'Importiert',
    trainingLoadScore: 'Trainingsbelastungsergebnis | Trainingsbelastungsergebnisse',
    value: 'Wert',
    latestResult: 'Letztes Ergebnis',
    latest: 'Letztes',
    pbResult: 'persönliche Bestleistung',
    planned: 'Geplant',
    actual: 'Eigentlich',
    volume: 'Volumen | Volumen',
    latestMaxLactate: 'letztes Maximallaktat',
    testScores: 'Prüfungsergebnis | Prüfungsergebnisse',
    vo2Max: 'VO2Max',
    vo2MaxPerKg: 'VO2Max per Kg',
    percentage: 'Prozent',
    latestP2000Index: 'letzter P2000m-Index',
    latestP6000Index: 'letzter P6000m-Index',
    trainingZonePercentage: 'Trainingszonen-Prozentsatz',
    spiderDiagram: 'Spinnendiagramm',
    personalBest: 'persönliche Bestleistung',
    mostRecent: 'Kürzlich',
    average: 'Durchschnitt',

    // reports
    trainingSummary: 'Trainingszusammenfassung',
    attendanceReportIsEmpty: 'Anwesenheitsberichte sind leer',
    selectAthlete: 'Athlet auswählen',
    ergoReportIsEmpty: 'Ergometer-Bericht ist leer',
    athleteName: 'Name des Athleten',
    side: 'Ruderseite',
    mainSquad: 'Hauptgruppe',
    bestInPeriod: 'Bestwert im Zeitabschnitt',
    firstInPeriod: 'erster Wert im Zeitabschnitt',
    lastInPeriod: 'letzter Wert im Zeitabschnitt',
    change: 'Änderung',
    pbGraph: 'persönliche Bestleistung- Grafik',
    doesNotHaveAnySpecificPieces: 'Hat keine bestimmten Teilstrecken.',
    doesNotHaveAnyPersonalBests: 'Hat keine persönlichen Bestwerte.',
    pieceNo: 'Strecken Nr',
    wattsKg: 'Watt / kg',
    rpeScore: 'RPE-Wert',
    ok: 'OK',
    noData: 'Keine Daten',
    morningMonitoringDefinitions: 'Morgendliche Überwachung - Begriffe',
    hrIncreaseBySevenToTenBeats: 'Die Herzfrequenz erhöht sich um 7-10 Schläge',
    differenceHasNarrowed: 'Der Unterschied hat sich verringert',
    decreased: 'Verringert',
    slightlyDehydrated: 'Leicht dehydriert',
    between: 'Zwischen',
    and: 'und',
    hrIncreaseByMoreThanTenBeats: 'Erhöhung der Herzfrequenz um mehr als 10 Schläge',
    injury: 'Verletzung',
    illness: 'Krankheit',
    by: 'durch',
    dehydrated: 'Dehydriert',
    trafficLights: 'Ampeln',
    wHr: 'Ruheherzfrequenz beim Aufwachen (rHFA)',
    sHr: 'Stehende Herzfrequenz beim Aufwachen (sHFA)',
    mass: 'Körpermasse',
    trainingScore: 'Trainingsergebnis',
    yourAthletesMorningMonitoringDataWillAppearHere: 'Die Morgenüberwachung Ihrer Athleten wird hier angezeigt.',
    yourAthletesIllnessAndInjuryDataWillAppearHere:
        'Verletzungen und Krankheiten Ihrer Athleten werden hier angezeigt.',
    yourAthletesQualityOfTrainingWillAppearHere:
        'Die Qualität des Trainings Ihrer Athleten wird hier angezeigt, sobald die Morgenüberwachung abgeschlossen ist.',
    report: 'Bericht',
    athleteErgoProgress: 'Entwicklung der Ergometerleistung',
    athleteErgoProgressText: 'Ruderergometerleistung Ihrer Athleten über die letzten Jahre.',
    athleteWaterProgress: 'Entwicklung der Ruderleistung',
    athleteWaterProgressText: 'Entwicklung der Ruderleistung auf dem Wasser differenziert nach Bootsklasse.',
    morningMonitoringText:
        'Der Bericht „Morgenüberwachung“ zeigt die morgendlichen Überwachungsdaten in einer Tabelle ' +
        'für die Gruppe oder Athleten an, die Sie ausgewählt haben.',
    goldMedalTime: 'Zielzeit',
    goldMedalTimeText:
        'Der Bericht „Zielzeiten“ zeigt Ihnen den Prozentsatz (%) GMT für jede Strecke an, die ihre ' +
        'Athleten absolviert haben. Dieser Bericht zeigt auch eine durchschnittliche Zielzeit für jede Strecke und ' +
        'jeden Athleten an.',
    sessionAttendance: 'Anwesenheitsbericht',
    sessionAttendanceText:
        'Der Anwesenheitsbericht zeigt Ihnen den Anwesenheitsstatus für Athleten und {label} in ' +
        'einem bestimmten Datumsbereich an. Dieser Bericht ermöglicht es Ihnen, die Teilnahme sowohl in der Zukunft ' +
        'als auch historisch zu betrachten.',
    ratingPerceivedExertion: 'Subjektives Belastungsempfinden (RPE)',
    ratingPerceivedExertionText:
        'Bewertung der subjektiv wahrgenommenen Anstrengung. Angabe der Durchschnittswerte und ' +
        'Anzeigen von Trainingseinheiten, die sich bei Ihrem Sportler deutlich davon abheben.',
    trainingSummaryText:
        'Zusammenfassung der Anzahl der Trainingseinheiten, Krankheits- und Verletzungstagen, ' +
        'Ergometer- und GPS-Daten, sowie des geplanten Trainingsumfanges.',
    trainingSummaryReportIsEmpty: 'Der Trainingszusammenfassungsbericht ist leer.',
    trainingSessions: 'Trainingseinheiten',
    sessionAttended: 'teilgenommene Trainingseinheiten',
    missedDueToIllness: 'Wegen Krankheit verpasst',
    missedDueToInjury: 'Wegen Verletzung verpasst',
    gpsDataImported: 'GPS-Daten (importiert)',
    ergoDataEntered: 'Ergometer Daten (eingegeben)',
    morningMonitoringCompleted: 'Morgenüberwachung abgeschlossen',
    waterReportIsEmpty: 'Ruderbericht ist leer.',
    allBoatTypes: 'Alle Bootstypen',
    export: 'Exportieren',
    exportToExcel: 'Nach Excel exportieren',
    aveGmt: 'durchschnittliche Weltbestzeit',
    reportsOverall: 'Überblick',
    rpeReportIsEmpty: 'Der RPE-Bericht für den ausgewählten Zeitraum ist leer.',
    reset: 'Zurücksetzen',
    stepTests: 'Stufentest',
    table: 'Tabelle | Tabellen',
    graph: 'Grafik | Diagramme',
    vo2Tests: 'Rampentests',
    k2Tests: '2000m Tests',
    k6Tests: '6000m Tests',
    errorsOccurredDuringImport: 'Fehler beim Import aufgetreten:',
    gmtReportIsEmpty: 'Der GMT-Bericht für den ausgewählten Zeitraum ist leer.',
    teamErgoSummary: 'Team Ergo Zusammenfassung',
    teamErgoSummaryText:
        'Mit dem Team Ergo-Bericht können Sie das Ergebnis und die Rate der Athleten in Ihrem Team über einen ' +
        'bestimmten Zeitraum sehen.',
    teamErgoSummaryIsEmpty:
        'Die Team-Ergebnisse für Ihre Ergos werden hier angezeigt. Die Gruppen Ergo Zusammenfasung für den ' +
        'ausgewählten Zeitraum ist leer.',
    dataEntered: 'Eingegebene Daten',
    noResultsForMorningMonitoringReport: 'Keine Ergebnisse für den morgendlichen Überwachungsbericht',
    individualView: 'Individuelle Ansicht',
    ergoReport: 'Ergometerleistung',
    rowingReport: 'Ruderleistung',
    test: 'Test | Tests',

    // errors
    pageNotFound: 'Seite nicht gefunden!',
    textErrorPage: 'Versuchen Sie zurückzugehen oder bitten Sie uns um Hilfe.',
    thereProblem: 'Es gibt ein Problem…',
    weWillBeBackSoon: 'Wir werden bald zurück sein!',
    text503Page:
        'Wir sind derzeit wegen Wartungsarbeiten nicht erreichbar. Wir erwarten, dass die Seite von Montag 9 ' +
        'Uhr GMT wieder erreichbar sein wird. Danke für Ihre Geduld.',
    outOfRangeError: 'Wert muss zwischen {min} und {max} sein',
    redirectingToDashboard: 'Umleitung zum Dashboard',
    doNotHavePermissionToSeeAthleteProfile: 'Du hast keine Erlaubnis, das Athletenprofil zu sehen.',
    unauthorized: 'Unauthorized',
    unauthorizedErrorPage: "You don't have permission to access this page.",

    // add crew
    addRecent: 'Zuletzt hinzugefügt',
    back: 'Zurück',
    showAthletes: 'Athleten anzeigen',
    hideAthletes: 'Athleten ausblenden',
    recentCrewsListEmpty: 'Letzte Mannschaftsliste ist leer',
    changeSportTypeWarning: 'Die Änderung des Bootstypes wird aktuelle Änderungen verwerfen. Möchten Sie fortfahren?',
    searchAthleteOrDragHere: 'Athleten suchen oder hierherziehen',
    boat: 'Bootsklasse | Bootsklasse',
    addingCrewsFor: 'Mannschaften hinzufügen für',

    // wall posts
    writeSomethingOnTheWall: 'Etwas auf die Pinnwand schreiben...',

    // billing
    currentPlanInfo: 'Aktuelle Planinformationen',
    billingInfo: 'Abrechnungsdaten',
    annually: 'Jährlich',
    annual: 'Einjährig',
    updatePaymentDetails: 'Zahlungsdetails aktualisieren',
    addPaymentDetails: 'Zahlungsdetails hinzufügen',
    changePlan: 'Plan ändern',
    selectPlan: 'Plan auswählen',
    updatePlan: 'Plan Aktualisieren',
    plan: 'Plan',
    perUser: 'pro Benutzer',
    for: 'für',
    subscriptionPlan: 'Abonnement',
    paymentDetails: 'Zahlungsdetails',
    member: 'Mitglied | Mitglieder',
    preferredCurrency: 'BEVORZUGTE WÄHRUNG',
    chooseAPlan: 'WÄHLEN SIE EINEN PLAN',
    billedMonthly: 'In Rechnung gestellt monatlich',
    perMonth: 'pro Monat',
    billedAnnually: 'Jährlich berechnet',
    perYear: 'pro Jahr',
    payBy: 'Zahlung per',
    card: 'Karte',
    paymentAmount: 'Zahlungsbetrag',
    nameOnCard: 'Name auf der Karte',
    cardNumber: 'Kartennummer',
    expiryDate: 'Verfallsdatum',
    securityCode: 'Sicherheitscode',
    securityCodeTooltip: 'Die letzten 3 Ziffern Ihrer CVC-Kartenprüfnummer auf der Rückseite Ihrer Karte',
    zipPostalCode: 'PLZ / Postleitzahl',
    zipPostalCodeTooltip: 'Bitte geben Sie hier Ihre Postleitzahl/ZIP ein',
    pay: 'Zahlen',
    freeTrial: 'Kostenlose Testphase',
    yourClubsFreeTrialExpiresIn: 'Ihre kostenlose Testversion läuft ab in',
    currency: 'Währung | Währungen',
    directBankTransfer: 'Direkte Banküberweisung',
    youSubscriptionHasExpired: 'Ihr Abonnement ist abgelaufen',
    nextBillDate: 'Nächstes Rechnungsdatum:',
    yourAccountHas: 'Ihr Konto hat',
    subscriptionCredit: 'Abo-Gutschrift',
    thisWillBeSubtractedFromNextPayment: 'Dieser wird von Ihrer nächsten Zahlung abgezogen',
    yourClubCurrentlyDoesNotHaveAPlan: 'Ihr Verein hat derzeit keinen Plan',
    currentPlan: 'Derzeitiger Plan',
    youTeamCurrentChargeFor: 'Ihre aktuellen Gebühren für Ihr Team',
    unlimited: 'Unbegrenzt',
    totalCost: 'Gesamtkosten',
    yourSubscriptionExpiredOn: 'Ihr Abonnement ist abgelaufen am',
    yourFreeTrialExpiredOn: 'Ihre kostenlose Testversion ist abgelaufen',
    payHere: 'Hier bezahlen',
    cancelSubscription: 'Abonnement kündigen',
    areYouSureToCancelSubscription: 'Möchten Sie das Abonnement wirklich kündigen?',
    expiryDateIsInvalid: 'Ablaufdatum ist ungültig',
    activePlan: 'Aktiver Plan',
    planExpired: 'Plan abgelaufen',
    billingPerUser: 'Abrechnung pro Benutzer',
    billingUnlimitedUsers: 'Unbegrenzte Benutzer',
    address1: 'Adresse 1',
    address2: 'Adresse 2',

    // billing licence expired
    orSwitchToAnotherClubOnLudum: 'Oder wechseln Sie zu einem anderen Verein bei Ludum',
    sendAdministratorLicenceNotification: 'Senden Sie eine Administratorlizenzbenachrichtigung',
    itLooksLikeYouLicenceHasExpiredWith: 'Ihre Lizenz scheint abgelaufen zu sein',
    clickBelowToSendANotificationToTheClubAdministratorToRenewYouLicence:
        'Klicken Sie unten, um eine Benachrichtigung an' +
        'den Vereinadministrator zu senden, um Ihre Lizenz zu erneuern',

    // onboarding
    welcomeToLudum: 'Willkommen bei Ludum',
    gettingStartedIntro1:
        'In diesem Panel haben wir die wichtigsten Schritte, um Rudergeräte erfolgreich einzusetzen. ' +
        'Wir haben festgestellt, dass Vereine, die diesen Prozess vollständig abschließen, eine viel höhere ' +
        'Erfolgsquote auf dem Wasser haben.',
    gettingStartedIntro2:
        'Die Einrichtung Ihres Vereines dauert weniger als 5 Minuten, bitte befolgen Sie jeden Schritt.',
    gettingStartedIntro3: 'Wenn Sie weitere Fragen haben, klicken Sie den blauen Knopf in der rechten unteren Ecke.',
    onboardingYourAgendaInfo1: 'Wir fassen hier Ihre nächsten Trainingseinheiten zusammen.',
    onboardingYourAgendaInfo2: 'anfangen',
    createASession: 'Traningseinheit erstellen',
    viewCalendar: 'Kalender anzeigen',
    calendar: 'Kalender',
    onboardingNextSessionInfo:
        'Eine ausführliche Zusammenfassung für Ihre nächste Trainingseinheit wird immer hier angezeigt. Sehen Sie sich ' +
        'Ihren vollständigen Zeitplan in Ihrem Kalendar an.',
    onboardingMostRecentSessionInfo: 'Die Ergebnisse Ihrer letzten Trainingseinheit werden immer hier angezeigt.',
    here: 'Hier',
    onboardingNotificationsInfo1:
        'In den Benachrichtigungen finden Sie eine Auflistung aller für Sie relevanten Informationen.',
    onboardingNotificationsInfo2: 'Sie können Ihre Benachrichtigungseinstellungen bearbeiten',
    gettingStarted: 'Fertig machen',
    gettingStartedShort: 'FM',

    // CTL
    ets: 'ETS',
    trimp: 'TRIMP',
    foster: 'Foster',
    scoreRange: 'Ergebnis-Bereich',
    totalScore: 'Gesamtergebnis',
    noTrainingScoreDataMessage:
        'Warum sehe ich hier keine Daten? Es gibt zwei Gründe: Entweder haben Sie noch keine ' +
        'Trainingsdaten importiert oder zu den gewählten Ergebnissen fehlen notwendige Angaben, d.h. ' +
        'Belastungsempfinden in der App beim Foster-Score oder importierte Herzfrequenzdaten von TRIMP oder ETS.',
    days7: '7 Tage',
    days28: '28 Tage',
    ratio: 'Verhältnis',
    you: 'Sie',

    // pagination
    perPage: 'Pro Seite',
    showing: 'Angezeigt',
    from: 'von',
    page: 'Seite | Seiten',

    // Training Load Scores
    cardiacTrainingLoadScores: 'Trainingsergebnisse',
    byWeek: 'wöchentlich',
    byMonth: 'monatlich',
    byDay: 'täglich',
    maxScore: 'Maximum',
    minScore: 'Minimum',

    // invite member
    addUser: 'Benutzer hinzufügen',
    inviteAdditionalUsersChargeMessage: 'Weitere Benutzer werden zu Ihrer nächsten Rechnung hinzugefügt',
    multiInviteAdditionalUsersChargeMessage:
        'Es kann eine zusätzliche Gebühr anfallen, wenn ein Benutzer Ihre Einladung akzeptiert.',

    // first time user
    invitedClubs: 'Eingeladene Vereine',

    // German import slider
    importDrvFile: 'DRV-Datei importieren',
    selectFileToUpload: 'Datei zum Hochladen auswählen',
    importFile: 'Datei importieren',
    row: 'Zeile | Reihen',

    // step tests
    lastTest: 'Letzter Test',

    // upgrade to Performance
    upgrade: 'Aufrüstung',
    upgradeNow: 'Jetzt aufrüsten',
    upgradeToPerformance: 'Auf Leistungsstufe aufrüsten',
    upgradeHeader1: 'Machen Sie Ihr Bestes noch besser',
    upgradeText1:
        'Für Trainer und Athleten gemacht, die jeden Aspekt ihres Trainings verbessern möchten.' +
        '<b>Leistungsstufe</b> lädt Ihr Rudererlebnis auf.',
    upgradeText1_2: 'Sie können jederzeit abbrechen oder ein Downgrade durchführen',
    upgradeHeader2: 'Sie Verwenden <b> Apps von Drittanbietern </b>, um Ihr Training weiterzuführen',
    upgradeText2:
        'Bei <b>GPS</b> und <b>Herzfrequenz</b> - Daten von deinen Trainingeinheiten Importieren' +
        'Ruderer können Ihnen detailliertes Feedback geben. Dies hilf Ihnen, Ihr Training besser zu verstehen.' +
        'Mit <b>Auto Import</b> haben wir die Integration von Ludum in Ihre bevorzugten Apps von Drittanbietern schnell und einfach gemacht.',
    upgradeText2_2: 'Willst du alles an einem Ort haben?',
    upgradeHeader3: '<b>Detaillierte Berichte</b> geben Ihnen alles, was Sie wissen müssen',
    upgradeText3:
        '<I>Leistungsstufe</i> ermöglicht Benutzern, Feedback zu erhalten, wie sich Ihre Trainingeinheiten anfühlten,' +
        'Sie können sich gegen die Goldmedaillen-Zeit vergleichen. Die Detaillierte Berichterstattung' +
        'sammelt diese Daten und gibt Ihnen diese in einem leicht verständlichen visuellen Format zurück.',
    upgradeText3_2: 'Wünschen Sie zusätzliches Feedback zu Ihrer Trainingeinheit?',
    upgradeHeader4: 'Mit unserem innovativen <b>Endurance Training Score</b> behalten Sie Ihre Trainingsbelastung.',
    upgradeText4:
        'Wir haben ein exklusives System für Ruderer entwickelt. Athleten behalten so den Überblick' +
        'bei ihrem Training im Laufe einer Saison. Durch das Vergleichen von der Herzfrequenz bei Trainingseiheiten ' +
        'kann ein ETS-Score hilfreich sein. Geben Sie an, wann Sie mehr oder weniger trainieren müssen, helfen Sie ' +
        'sich selbst zu verstehen, warum Verletzungen auftreten.',
    upgradeText4_2: 'Möchten Sie die Spitzentechnologie nutzen?',
    upgradeText5: '… und mehr',
    upgradeHeader6: 'Alternative Trainingeinheiten',
    upgradeText6: 'Speichern Sie alternative Trainingeinheiten in einer Einheit, um den Vergleich zu erleichtern.',
    upgradeHeader7: 'Sehen Sie sich eine Detailansicht jeder Woche an und vergleichen Sie Woche zu Woche',
    upgradeText7: 'Sehen Sie sich eine Aufgliederung jeder Woche an und vergleichen Sie Woche zu Woche.',
    upgradeHeader8: 'Konkurrenzeinheiten',
    upgradeText8:
        'Ändern Sie den Status der Trainingseinheiten, erlauben Sie den Athleten alle oder nur ihre eigenen Daten ' +
        'anzuzeigen.',

    // welcome
    bePartOfATeam: 'Sei Teil eines Teams',
    getStarted: 'Fangen Sie an',
    trainLikePro: 'Trainieren Sie wie ein Profi',
    team: 'Team | Teams',
    individual: 'Individuell',
    welcomeToLudumMessage: 'Bitte wählen Sie aus, wie Sie Rudergeräte verwenden möchten',
    trackYourProgress: 'Verfolgen Sie Ihren Fortschritt',
    allInYourHands: 'Alles in Ihren Händen',
    organizeYourTeam: 'Organisieren Sie Ihr Team',
    communicateWithYourTeam: 'Kommunizieren Sie mit Ihrerm Team',
    startUsingLudumToday: 'Beginnen Sie mit Ludum heute',
    startOver: 'Wieder anfangen',

    // session results
    selectAthleteFromDropdown: 'Bitte wählen Sie einen Athleten aus dem Dropdown-Menü aus',
    avePeakForcePosition: 'Durch. Spitzenkraftposition',

    // session attendance
    listOfAthletesIsEmpty: 'Die Liste der Athleten ist leer.',
    listOfCoachesIsEmpty: 'Die Liste der Trainer ist leer.',

    // quick assign
    cannotAddAnythingWhileEverybodyIsSelected: 'Es kann nichts hinzugefügt werden, während alles ausgewählt ist',

    // import data
    noSessions: 'Keine Trainingseinheit',

    // Add MM
    sleepTime: 'Schlafzeit',

    // Notes
    attach: 'Anhängen',
    noFileInThisNote: 'Keine Datei in dieser Notiz',
    fileName: 'Dateiname',
    delete: 'Löschen',
    byDate: 'Nach Datum',
    asc: 'aufsteigend',
    desc: 'absteigend',
    areYouSureToRemoveNote: 'Möchten Sie die Notiz wirklich entfernen?',
    addPrivateNoteAboutSession: 'Fügen Sie eine private Notiz über die Trainingseinheit hinzu',
    addPrivateNoteAboutEvent: 'Fügen Sie eine private Notiz über das Ereignis hinzu',
    areYouSureToRemoveFile: 'Möchten Sie die Datei wirklich entfernen?',
    privateNote: 'Private Notiz | Private Notizen',
    addPrivateNote: 'Private Notiz hinzufügen',

    // Search
    search: 'Search',
    searchProfileSquadsEvents: 'Search for profiles, squads and events',
    seeAllSquads: 'Alle {label} anzeigen',
    seeAllSessions: 'Alle Trainingseiheiten anzeigen',
    seeAllProfiles: 'Alle Profile anzeigen',
    event: 'Ereignis | Ereignisse',
    noSearchResults: 'Keine Suchergebnisse',
    doNotHavePermissionToViewThisPage: 'Sie haben keine Berechtigung, diese Seite zu besuchen.',

    // Login Page
    orLoginWith: 'Oder melden Sie sich an mit',
    alreadyMember: 'Schon ein Mitglied',
    resendActivationEmail: 'Aktivierungs-E-Mail erneut versenden',

    // Create/edit club
    selectCountry: 'Land auswählen',
    selectTimezone: 'Zeitzone auswählen',

    // Home
    lastSession: 'Letzte Trainingseinheit',
    avgSplit: 'Durch. Split',
    vsLast: 'vergleich zu letzter',
    meter: 'Meter | Meter',
    trainingIntensity: 'Trainingsintensität',
    per: 'pro',
    backToNotification: 'Zurück zur Benachrichtigung',
    setTime: 'Zeit einstellen',
    hoursOfSleep: 'Schlafdauer',
    sessionToImport: 'Trainingseinheit zum Importieren',
    widgetAutoImportSubtitle: 'Sie haben keine neuen Einheiten zu importieren.',
    widgetAutoImportIntro: 'Ihr nächster Import wird hier angezeigt, sobald dieser ausgeführt wird.',
    myTraining: 'Mein Training',
    health: 'Gesundheit',
    trainingScores: 'Trainingsergebnisse',
    noIntensityForThis: 'Keine Intensität hierfür',
    agenda: 'Agenda',
    unread: 'nicht gelesen',

    // Invitation for membership
    saveYourProfile: 'Speichern Sie Ihr Profil',
    cancelThisInvitation: 'Diese Einladung stornieren',
    acceptTheInvitation: 'Diese Einladung akzeptieren',
    wouldYouLikeToJoin: 'Würdest du gerne beitreten?',
    hello: 'Hallo',
    textInvitedAccount: 'Sie wurden eingeladen, sich anzuschließen',
    textInvitedWithAccount1: 'Indem Sie die Einladung annehmen',
    textInvitedWithAccount2: 'wird diese in Ihrem Konto hinzugefügt.',
    textInvitedWithoutAccount: 'Wenn Sie die Einladung annehmen, können Sie weiterhin ein Konto in Ludum erstellen.',
    textOnSaveYourProfile: 'Wenn Sie Ruderer verwenden möchten, können Sie fortfahren, indem Sie Ihr Profil speichern.',
    invitationAlreadyAccepted: 'Einladung bereits angenommen',
    invitationExpired: 'Einladung abgelaufen',

    // Add scores
    sendNotificationAfterSave: 'Benachrichtigung nach dem Speichern senden',
    viewResultsAfterSave: 'Ergebnisseite nach dem Speichern anzeigen',

    // kayak/canoe
    kayakCanoe: 'Kajak/Kanu',
    rowing: 'Rudern',
    athleteRowingProgress: 'Enwicklung der Ruderleistung',
    athleteRowingProgressText: 'Entwicklung der Ruderleistung auf dem Wasser differenziert nach Bootsklasse.',

    // default Ludum user
    ludum: 'Ludum',
    user: 'Benutzer | Users',

    // Session view results - new
    yourResults: 'Deine Ergebnisse',
    summary: 'Zusammenfassung',
    imports: 'Importe',
    pieceResults: 'Streckenergebnisse',
    piecesSummary: 'Streckenübersicht',
    athleteHeartRate: 'Sportler Herzfrequenz',
    totalReps: 'Gesamtwiederholungen',
    typeOfExercises: 'Übungstypen',
    athleteEnduranceTrainingScore: 'Athlet ETS',
    noFilesUploaded: 'Es wurden keine Dateien hinzugefügt, bitte importiere Daten',
    showMore: 'Mehr anzeigen',
    crewHr: 'Mannschaftsherzfrequenz',
    noImportedFiles: 'Es wurden keine Dateien importiert. Bitte importieren Sie Dateien, um die Ergebnisse anzuzeigen',
    showAll: 'Alles anzeigen',
    aveTimeScore: 'Durch. Zeitergebnis',
    aveDistanceScore: 'Durch. Distanzergebnis',
    viewResults: 'View Results',

    // Create/edit club
    website: 'Webseite',
    defaultSport: 'Standard Sport',
    selectDefaultSport: 'Wählen Sie den Standardsport aus',
    unitsOfMeasurement: 'Maßeinheiten',
    selectUnitsOfMeasurement: 'Maßeinheiten auswählen',

    // not authorized
    notAuthorizedToSeeThisPage: 'Sie haben keine Berechtigung, diese Seite zu besuchen',

    // titles
    titleLogin: 'Anmelden',
    titleSignUp: 'Registrieren',
    titleForgotPassword: 'Kennwort vergessen',
    titleHome: 'Home',
    titleSession: 'Trainingseinheit',
    titleSessions: 'Trainingseinheit',
    titleAddCrews: 'Mannschaften hinzufügen',
    titleEditCrews: 'Mannschaften bearbeiten',
    titleEvent: 'Wettkampf',
    titleReports: 'Bericht',
    titleSettings: 'Einstellungen',
    titleSquads: '{label}',
    titleClubMembers: 'Vereinmitglieder',
    titleProfile: 'Profil',
    titleLicenceExpired: 'Lizenz abgelaufen',
    titleUpgrade: 'Aufrüstung',
    titleWelcome: 'Willkommen',
    titleSearchResults: 'Suchergebnisse',
    titleCrews: 'Mannschaften',
    titleInvitationForMembership: 'Einladung zur Mitgliedschaft',
    titleResendActivationEmail: 'Aktivierungs-E-Mail erneut schicken',

    // Crews
    saveChanges: 'Änderungen speichern',
    isAlreadyOn: 'ist schon dran',

    /// RPE
    veryEasy: 'Sehr leicht',
    easy: 'Einfach',
    moderate: 'Mäßig',
    aBitExhausting: 'Ein bisschen anstrengend',
    exhausting: 'Anstrengend',
    veryExhausting: 'Sehr anstrengend',
    veryVeryExhausting: 'Sehr, sehr anstrengend',
    maximumEffort: 'Maximaler Aufwand',

    // settings - club list
    areYouSureToDeleteClub: 'Möchten Sie den Verein wirklich löschen?',

    // session
    thisSessionBelongsToAnotherClub: 'Diese Trainingseinheit gehört einem anderen Verein',
    thisEventBelongsToAnotherClub: 'Dieses Ereignis gehört einem anderen Verein.',

    // rpe
    informationRpeTitle: 'Die Anzahl der Sterne entspricht den Nummern',

    favorite: 'Favoriten',

    deleteClub: 'Verein löschen',
    editClub: 'Verein bearbeiten',
    youAreAlreadyInThisClub: 'Sie sind bereits in diesem Verein!',
    notificationWillBeSentImmediately: 'Benachrichtigung wird sofort gesendet',
    clubEmail: 'Verein E-Mail',
    clickHereTo: 'Hier klicken, um',
    useWithoutClub: 'Verwenden ohne Verein',

    allDayEvent: 'Ganztägige Veranstaltung',
    tag: 'Stichwort | Stichworte',

    // add member
    invalidFile: 'ungültige Datei',
    invalidFileType: 'ungültiger Dateityp',
    uploadFromFile: 'aus Datei hochladen',
    sampleFile: 'Beispieldatei',
    enterManuallyOr: 'Manuell eingeben oder',
    use: 'Benutzen',
    toEasyMakeMultiMembersImport: 'um einfach zu machen, dass mehrere Mitglieder importieren',
    chooseFromFileOrDragAndDrop: 'Wählen Sie eine Datei aus oder benutzen Sie Drag & Drop',
    added: 'Hinzugefügt',
    error: 'Fehler | fehler',
    addMember: 'Mitglied hinzufügen',
    resetAll: 'Alles zurücksetzen',
    addNew: 'Neu hinzufügen',
    membersUploadedSuccessfully: 'Mitglieder erfolgreich hochgeladen.',
    userWillBeInvitedToClub: 'Der Benutzer wird eingeladen, dem Verein beizutreten',
    clickToInviteUserToClub: 'Klicken Sie hier, um Benutzer zum Verein hinzuzufügen',

    // session attendance tooltip
    viewAllParticipantsOnThisSession: 'Alle Teilnehmer dieser Trainingseinheit anzeigen',

    // Update notification
    webAppUpdated: 'Es gibt eine neue Version von Ludum. Bitte',
    webAppUpdatedReload: 'neu laden',

    // calendar share link
    shareCalendarLink: 'Kalender-Link freigeben',
    shareLudumCalendar: 'Ludum-Kalender teilen',
    copyLink: 'Link kopieren',
    copiedToClipboard: 'In die Zwischenablage kopiert',
    shareIntroTopTextModal: 'Kopieren Sie diese URL, um den Ludum-Kalender für andere Plattformen freizugeben.',
    read: 'Lesen',
    tutorial: 'Tutorial',
    shareIntroDownTextModal: 'Informationen zum Teilen des Ludum Kalenders.',

    // crews page
    category: 'Category | Categories',
    age: 'Alter',
    sportType: 'Sportart',
    deleteSelectedCrews: 'Delete selected crews',
    noPermission: 'No permission',
    youDontHavePermissionToDeleteThisCrew: "You don't have permission to delete this crew",
    areYouSureToDeleteSelectedCrews: 'Are you sure you want to delete selected crews?',
    crewsSuccessfullyDeleted: 'Crews successfully deleted.',

    // reports - morning monitoring
    numberOfInjuryIllness: 'Nummer der Verletzungen / Krankheiten',
    ave: 'Durchschn.',
    maxGmtByPiece: 'Max GMT by piece',

    // Team Ergo Summary report
    missingOrIncompleteResults: 'Fehlende oder unvollständige Ergebnisse',
    spm: 'spm',

    // crews
    showFilter: 'Filter anzeigen',
    crewMessageNoData1: 'Um eine Mannschaft hinzuzufügen, wählen Sie eines der oben angezeigten Boote.',
    crewMessageNoData2: 'Mannschaften werden zu allen Strecken hinzugefügt.',
    publish: 'Veröffentlichen',
    unpublish: 'Veröffentlichung rückgängig machen',
    seatRacing: 'Seat racing',
    youHaveToSelectCrewFirst: 'Sie müssen zuerst eine Mannschaft auswählen.',
    thereAreNoCrews: 'Es gibt keine Mannschaften',

    // home widget
    noSquadsInThisClub: 'Keine {label} in diesem Verein',
    addSquads: 'Gruppen {label} hinzufügen',

    // Resend activation email
    resendActivationEmailIntroText:
        'Ihr Benutzerkonto wurde noch nicht aktiviert. Bitte überprüfen Sie Ihre E-Mail, um Ihr Benutzerkonto ' +
        'zu verifizieren.',

    // finish club setup - notification
    finishClubSetup: 'Es ist empfehlenswert, die Verein-Einrichtung an einem Desktop/PC zu erledigen.',

    // create session/event further action modal
    saveAndCreateNew: 'Save and Create new',
    saveAndExit: 'Save and exit',
    returnToSessionCreate: 'Return to session create',
    addCrews: 'Add Crews',

    profileImage: 'Profile image',

    // team report
    kaizenTeam: 'Kaizen Team',
    kaizenTeamText:
        'Der Kaizen Team Bericht gibt Ihnen die Möglichkeit, den Verbesserungswert Ihrer Athleten im Laufe ' +
        'der Zeit zu vergleichen.',
    noAthleteOrSquadMessage:
        'Willkommen zum Kaizen Team Report! Dieser Bericht gibt Ihnen die Möglichkeit,  den Verbesserungswert ' +
        'Ihrer Athleten im Laufe der Zeit zu vergleichen.<br><br>' +
        'Es beinhaltet auch die zusätzliche Option des Vergleiches mit der tatsächlichen Trainingsbelastung jedes einzelnen Athleten.<br>' +
        'Um Daten anzuzeigen, wählen Sie bitte einige Athleten aus - entweder nach Name oder durch Auswahl einer Gruppe. ' +
        'Wählen Sie dann einen Zeitraum aus, an welchem Sie Interesse haben.',
    pleaseSelectAthlete: 'Bitte Ahtleten auswählen',
    trainingTime: 'Trainingszeit',
    sessionsCompleted: 'Trainingseinheit abgeschlossen',
    sessionsMissed: 'Verpasste Trainingseinheiten',
    sessionDate: 'Datum der Trainingseinheit',
    percentageImprovement: 'Verbesserung in Prozent',
    meanPercentageOfGroup: 'Durchschn. Prozente der Gruppe',
    maxPercentageOfGroup: 'Max. Prozente der Gruppe',
    cumulativeImprovement: 'Komulative Verbesserung',
    noTrainingLoadScoreData: 'Keine Daten zur Trainingsbelastung',
    noPercentageImprovementData: 'Keine Prozent-Daten zur Trainingsbelastung',
    perWeek: '/Woche',
    structure: 'Struktur| Strukturen',
    cumulativeImprovementTooltip:
        'Diese Grafik zeigt die Verbesserung jedes Athleten auf dem Indoor-Rudergerät über' +
        'den ausgewählten Zeitraum. Die Verbesserung wird durch den Vergleich ähnlicher Sitzungen produziert und berechnet ' +
        'die Verbesserung (in Watts) zwischen den beiden. Die bedeutet, dass Verbesserungen zweier Athleten verglichen werden können,' +
        'auch wenn Sie andere Ergometer-Trainingseinheiten machen.',
    trainingLoadScoreTooltip:
        'Hier sehen Sie die Veränderung der Trainingsbelastung jedes einzelnen Athleten, welchen Sie ' +
        'über einen gewissen Zeitraum auswählen.<br><br>' +
        'In dieser Grafik werden vier Arten von Trainingsbelastungen angeboten.<br>' +
        '    1. ETS – Endurance Training Score<br>' +
        '    2. Trimp – Training Impulse<br>' +
        '    3. Foster – RPE x training time<br>' +
        '    4. RPE – Rate of Perceived Effort',
    athletesSummaryTooltip:
        'Eine Liste aller ausgewählten Athleten mit Gesamtzeit der Trainingseinheiten, wie auch die ' +
        'Nummer aller abgeschlossenen und verpassten Trainignseinheiten kann hier angezeigt werden. Auch kann der ' +
        'Gesamtwert wie auch der wöchentliche Durchschnitt der Trainingsbelastung angezeit werden, was Sie in der ' +
        'Grafik oben auswählen könenn. Die allgemeine Verbesserung wird hier auch dargestellt, um die verbesserte ' +
        'Leistung mit dem Training zu vergleichen.',
    individualSummaryTooltip:
        'Sobald Sie einen Athleten aus Ihrer Gruppe ausgewählt haben, werden alle' +
        'Ergometer Trainingseinheiten angezeigt, welche in diesem Zeitraum ausgeführt wurden. Wir zeigen ' +
        'Verbesserungen für jede einzelne Trainingseinheit an, sowie auch die Gesamtverbesserung. Ebenso als ' +
        'Vergleich zeitgen wir die durschn. und max. Verbesserung für diese Trainingseinheit.',
    individualResults: 'Individuelle Ergebnisse',
    showCrew: 'Show crew',

    sessionInfo: 'Session info',

    quickAssignInfo:
        'In order to make it easier to create training sessions for many people in one go we have developed the ' +
        'quick assign feature. Please enter the name of a squad or a list of people into this box then simply drag ' +
        'and drop sport types, recent sessions or favourites into the day and time you want the session to happen. ' +
        'All those names will be assigned to those sessions and the session structures will also be transposed from ' +
        'the recents and favourites.',
        
    messageFooterPublicPages: 'Your training history only begins the day you start collecting your training data.',
    morningMonitoringLog: 'Morning Monitoring Log',
    privacySettings: 'Privacy Settings',
    allCoaches: 'All Coaches',
    specificCoaches: 'Specific Coaches',
    allCoachesExcept: 'All Coaches except',
    onlyMe: 'Only me',
    whoCanSeeMyProfileAndReports: 'Who can see my profile and reports?',
    float: 'Float',
    garmin: 'Garmin',
    polar: 'Polar',
    suunto: 'Suunto',
    select: 'Select',

    // Equipment List.
    equipmentList: 'Equipment List',
    allEquipment: 'All Equipment',
    equipmentCategory: 'Equipment Category',
    categoryName: 'Category name',
    enterNameOfNewCategory: 'Enter name of new category',
    addCategory: 'Add Category',
    editCategory: 'Edit Category',
    deleteCategory: 'Delete Category',
    areYouSureToDeleteCategory: 'Are you sure you want to delete this category?',
    addEquipment: 'Add Equipment',
    noEquipment1: 'No equipment. Click to',
    noEquipment2: 'to add on list of equipment.',
    noCategory1: 'No category. Click to',
    noCategory2: 'to add equipment category.',
    searchByNameOrSerialNumber: 'Search by name or serial number',
    serialNumber: 'Serial number',
    dateBought: 'Date Bought',
    dateSold: 'Date Sold',
    minimaxSpecific: 'Minimax specific',
    hardwareSettings: 'Hardware settings',
    samplingRates: 'Sampling rates',
    totalRunningTime: 'Total running time',
    correctionFactors: 'Correction factors',
    unitIntegrity: 'Unit integrity',
    dataStorageCapacity: 'Data storage capacity',
    memoryAvailable: 'Memory available',
    accuracyFactors: 'Accuracy factors',
    lastLog: 'Last Log',
    viewAllLogs: 'View all logs',
    batteryStatus: 'Battery status',
    deleteEquipment: 'Delete Equipment',
    removeEquipment: 'Remove Equipment',
    areYouSureToRemoveEquipment: 'Are you sure you want to remove this equipment?',
    assignEquipment: 'Assign Equipment',
    assignDevice: 'Assign device',
    assignedBy: 'Assigned by',

    // Challenges.
    challenge: 'Challenge | Challenges',
    viewMore: 'View more',
    allChallenges: 'All Challenges',
    addChallenge: 'Add Challenge',
    addTeam: 'Add Team',
    info: 'Info',
    teamInfo: 'Team Info',
    myTeams: 'My Teams',
    maximum: 'maximum',
    athletesPerTeam: 'athletes per team',
    myTeamResults: 'My Team Results',
    searchByTeamName: 'Search by Team Name ',
    created: 'Created',
    numberOfMembers: 'No. Of Members',
    editChallenge: 'Edit Challenge',
    deleteChallenge: 'Delete Challenge',
    teamName: 'Team Name',
    enterNameOfNewTeam: 'Enter Name of New Team',
    areYouSureToRemoveChallengeTeam: 'Are you sure you want to remove this challenge team?',
    addChallenges: 'Add Challenges',
    currentChallenges: 'Current Challenges',
    futureChallenges: 'Future Challenges',
    pastChallenges: 'Past Challenges',
    teamsLimitation: 'Teams Limitation',
    visitLudum: 'Visit Ludum',
    totalNoOfStrokes: 'Total No. of Strokes',
    pos: 'Pos.',
    poweredBy: 'Powered by',
    challengeBoardInfoText:
        'Ludum enables you and your team to keep winning and achieving better results through the power of ' +
        'performance data, better organisation and smooth communication. Empower athletes to train at the right ' +
        'intensity levels, helping to prevent injury and illness and get the edge that sets the winners apart ' +
        'from others, while a coach has a convenient way of adapting training plans to achieve high performance and ' +
        'a steady athlete development pace.',
    aveStrokeRate: 'Ave. Stroke Rate',
    howToUseChallenges: 'How to use challenges',
    step: 'Step',
    challengeStep1Text: 'Login or Sign up on',
    challengeStep2Text: 'Select Challenge and "Add Team"',
    challengeStep3Text: 'and connect to Ludum',
    download: 'Download',
    floatApp: 'Float app',
    thereAreNoAthletes: 'There are no athletes',
    endTime: 'End Time',
    noOfHeartbeats: 'No. of Heartbeats',
    publicChallengesHowToUseTitle: 'Challenges for all',
    publicChallengesHowToUseSubTitle: 'Compete or Complete with more sports',
    publicChallengesHowToUseText1: 'Ludum Challenges offers the most innovative series of challenges, appealing to those who want to compete or complete. Whether you want to run, swim, cycle or row indoors, we have it here for you!',
    publicChallengesHowToUseText2: 'Compete: Pit yourself against other individuals or teams to see how you compare',
    publicChallengesHowToUseText3: 'Complete: Test your own determination. It does not matter what your level of performance is you can still be at the top of the leaderboard.',
    publicChallengesHowToUseText4: 'Challenges will be for specific sports or all sports.',
    publicChallengesHowToUseText5: 'See our',
    publicChallengesHowToUseText5Link: 'Challenges Guide',
    publicChallengesHowToUseSportTypes: 'Sport Types',
    publicChallengesHowToUseSportTypesText: 'Swimming, Running, Cycling, Rowing Indoors',
    publicChallengesHowToUseCompete: 'Compete',
    publicChallengesHowToUseCompeteText: 'fastest, higher, stronger',
    publicChallengesHowToUseComplete: 'Complete',
    publicChallengesHowToUseCompleteText: 'most time, most distance, most strokes (Indoor Rowing), most heartbeats (all Sports)'
};
